/**
 * Shows repeated rows of fields one at a time, behind an "add another" button.
 *
 * A row is every field with the CSS class `repeat-row-N`, numbered from 1; the
 * button is a `.repeat-add` inside an HTML field. The first rows always show,
 * as many as the button's `data-rows` says (one without it); the button opens
 * the next, up to the last. Rows the server sent back with something in them
 * stay open.
 *
 * The rows are all in the markup, so without JavaScript every one shows and the
 * form still works.
 */
( function() {
	document.querySelectorAll( '.gform_wrapper form' ).forEach( setup );

	/**
	 * Watch one form.
	 *
	 * @param {HTMLFormElement} form The form.
	 */
	function setup( form ) {
		const button = form.querySelector( '.repeat-add' );
		const rows = collect( form );

		if ( ! button || rows.length < 2 ) {
			return;
		}

		// Stacked on a narrow screen, each row after the first needs a line above it.
		rows.slice( 1 ).forEach( function( row ) {
			row[ 0 ].classList.add( 'is-repeat-row-start' );
		} );

		// Open the first rows, and up to the last row with anything in it, or
		// flagged by the server.
		let shown = Math.min( Math.max( parseInt( button.dataset.rows, 10 ) || 1, 1 ), rows.length );

		rows.forEach( function( row, index ) {
			if ( row.some( function( field ) {
				return hasValue( field ) || field.classList.contains( 'gfield_error' );
			} ) ) {
				shown = Math.max( shown, index + 1 );
			}
		} );

		function render() {
			rows.forEach( function( row, index ) {
				row.forEach( function( field ) {
					field.classList.toggle( 'is-repeat-collapsed', index >= shown );
				} );
			} );

			button.hidden = shown >= rows.length;
		}

		button.addEventListener( 'click', function() {
			shown = Math.min( shown + 1, rows.length );
			render();

			const control = rows[ shown - 1 ][ 0 ].querySelector( 'input:not([type="hidden"]), textarea' );

			if ( control ) {
				control.focus();
			}
		} );

		render();
	}

	/**
	 * The form's rows, in order.
	 *
	 * @param {HTMLFormElement} form The form.
	 * @return {HTMLElement[][]} The fields of each row.
	 */
	function collect( form ) {
		const rows = [];

		form.querySelectorAll( '.gfield[class*="repeat-row-"]' ).forEach( function( field ) {
			const match = field.className.match( /\brepeat-row-(\d+)\b/ );

			if ( match ) {
				const index = parseInt( match[ 1 ], 10 ) - 1;

				rows[ index ] = rows[ index ] || [];
				rows[ index ].push( field );
			}
		} );

		return rows.filter( Boolean );
	}

	/**
	 * Whether anything is typed into a field.
	 *
	 * @param {HTMLElement} field A field.
	 * @return {boolean} True when it holds a value.
	 */
	function hasValue( field ) {
		return Array.from( field.querySelectorAll( 'input:not([type="hidden"]), textarea' ) ).some( function( control ) {
			return '' !== control.value.trim();
		} );
	}
}() );
